import React, { useContext, useState } from "react";
import { Card, CardActions, CardContent, Button, Grid } from "@mui/material";
import { AxiosContext } from "../../../app/assets/axios/admin/AxiosComponent";
import { useForm } from "react-hook-form";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import { postCreateForm } from "../../../actions/admin/actionCreators";
import TextFieldComponent from "../../FormAddInputComponent/TextField";
import SelectOptionComponent from "../../FormAddInputComponent/SelectOption";
import { AppBarSpacer, CardHeaderCss } from "../../../css/Admin-css/listing-css";
import CollapsedBreadcrumbs, { BreadcrumbsContext } from "../../../layouts/admin/breadcrumb";

export default function PaymentTypeCreate(props) {
    const navigate = useNavigate();
    const api = useContext(AxiosContext);
    const { enqueueSnackbar } = useSnackbar();
    const [status, setStatus] = useState("");

    const {
        handleSubmit,
        control,
        setValue,
        formState: { errors },
    } = useForm({
        mode: "all",
        defaultValues: {
			code: "",
			name: "",
			seq_no: 1,
            status: "",
		},
    });

    const statusList = [
        { id: "A", name: "Active" },
        { id: "I", name: "Inactive" },
    ];

    const [breadcrumbArr, setBreadcrumbArr] = React.useState([
        {
            text: "Payment Type",
            link: "/admin/payment-type-list",
        },
        {
            text: "Create Payment Type",
            link: "",
        },
    ]);

    const onSubmit = handleSubmit(async (data) => {
        document.getElementById("splash-screen").classList.remove("hidden");

        const response = await postCreateForm({
            api: api,
            data: data,
            method: "POST",
            url: "createPaymentType",
            enqueueSnackbar,
        });

        if (response) {
            if (response.data.status === 200) {
                enqueueSnackbar(response.data.data.msg, {
                    variant: response.data.data.msgType,
                    anchorOrigin: {
                        vertical: "top",
                        horizontal: "center",
                    },
                });
                if (response.data.data.msgType == 'success') navigate("/admin/payment-type-list");
            }
        }
        document.getElementById("splash-screen").classList.add("hidden");
    });

    const onSelectChangeHandler = (name) => (event) => {
        const value = event.target.value;
        if (name == "status") {
            setStatus(value);
        }
        setValue(name, value);
    };

    return (
        <>
            <BreadcrumbsContext.Provider value={[breadcrumbArr, setBreadcrumbArr]} >
                <CollapsedBreadcrumbs />
            </BreadcrumbsContext.Provider>
            <Card>
                <CardHeaderCss title="Payment Type Form" />
                <CardContent>
                    <form>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6} style={{ paddingTop: 0 }}>
                                <TextFieldComponent
                                    control={control}
                                    name="code"
                                    marginType="normal"
                                    label="Code"
                                    type="text"
                                    rules={{
                                        required: {
                                            value: true,
                                            message: "This field is required",
                                        },
                                    }}
                                    errors={errors}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} style={{ paddingTop: 0 }}>
                                <TextFieldComponent
                                    control={control}
                                    name="name"
                                    marginType="normal"
                                    label="Name"
                                    type="text"
                                    rules={{
                                        required: {
                                            value: true,
                                            message: "This field is required",
                                        },
                                    }}
                                    errors={errors}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} style={{ paddingTop: 0 }}>
                                <TextFieldComponent
                                    control={control}
                                    name="seq_no"
                                    placeholder="Single Number like 1 or 2 or 3"
                                    marginType="normal"
                                    label="Sequence No"
                                    type="number"
                                    rules={{
                                        required: {
                                            value: true,
                                            message: "This field is required",
                                        },
                                    }}
                                    errors={errors}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} style={{ paddingTop: 0 }}>
                                <SelectOptionComponent
                                    control={control}
                                    name="status"
                                    placeholder="Status"
                                    label="Status"
                                    option={statusList}
                                    rules={{
                                        required: {
                                            value: true,
                                            message: "This field is required",
                                        },
                                    }}
                                    errors={errors}
                                    onChangeHandler={onSelectChangeHandler("status")}
                                    value={status}
                                />
                            </Grid>
                        </Grid>
                    </form>
                </CardContent>
            </Card>
            <AppBarSpacer />
            <CardActions
                style={{ justifyContent: "center", marginBottom: "16px" }}
            >
                <div align="center">
                    <Button
                        variant="contained"
                        color="primary"
                        type="submit"
                        onClick={onSubmit}
                    >
                        Create
                    </Button>
                </div>
            </CardActions>
        </>
    );
}
